import Client from './Client';
import {Change, Project} from "../models";
import type { SearchFilters } from '../utils/searchFilters';
import { filtersToQuery } from '../utils/searchFilters';

export type { SearchFilters } from '../utils/searchFilters';
export { hasActiveSearchFilters, filtersToQuery } from '../utils/searchFilters';

class Search extends Client {
    search(query: string, lang: string, filters?: SearchFilters) {
        const params: AnyObj = {
            lang,
            ...filtersToQuery(filters),
        };
        if (query?.trim())
            params.query = query.trim();

        return this.GET(`/search`, params)
            .then(response => response.json())
            .then(json => {
                if (json.projects)
                    json.projects = json.projects.map((p: AnyObj) => new Project(p))
                else
                    json.projects = [];
                if (json.changes)
                    json.changes = json.changes.map((c: AnyObj) => new Change(c))
                else
                    json.changes = [];
                return json;
            })
            .catch(error => {
                console.error('Search API error:', error);
                throw error;
            });
    }
}

const SearchApi = new Search();

export default SearchApi;
